<template>
  <v-container>
    <Dialog
      :show="adDialog1"
      :object="objDeleteExtra"
      @delete="eliminarExtra"
      @close="close"
    />
    <Dialog
      :show="adDialog2"
      :object="objDeletePrecio"
      @delete="eliminarPrecio"
      @close="close"
    />
    <Modal1
      @save="guardarExtra"
      @close="close"
      :object="itemActExtra"
      :update="update"
      :detalle="detalle"
      :show="abrirModal1"
    />
    <Modal2
      @save="guardarPrecio"
      @close="close"
      :object="itemActPrecio"
      :update="update"
      :detalle="detalle"
      :show="abrirModal2"
    />
    <template>
      <v-row>
        <v-col cols="12" md="12">
          <span class="align-center headline">
            Extras
          </span>
        </v-col>
        <v-col cols="12" xs="11" md="11">
          <v-btn color="primary" dark class="mb-2" @click="nuevoExtra">Nuevo Extra</v-btn>
        </v-col>
        <v-col cols="12" xs="1" md="1">
          <v-btn color="primary" dark class="mb-2" @click="nuevoPrecio">Nuevo Precio</v-btn>
        </v-col>
      </v-row>
    </template>
    <v-row>
      <v-col cols="12" sm="6">
        <Table
          @edit="editarClickExtra"
          @delete="eliminarClickExtra"
          @detalle="detalleClickExtra"
          :headers="headersExtras"
          :arrayList="extras"
          :opciones="true"
          :title="extraStr"
          :extra="true"
        />
      </v-col>
      <v-col cols="12" sm="6">
        <Table
          @edit="editarClickPrecio"
          @delete="eliminarClickPrecio"
          @detalle="detalleClickPrecio"
          :headers="headersPrecios"
          :arrayList="precio_extras"
          :opciones="true"
          :title="preciosStr"
          :precio_extra="true"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState, mapActions } from "vuex";
import Table from "@/components/base/Table.vue";
import Modal1 from "@/components/base/modal/ModalExtra.vue";
import Modal2 from "@/components/base/modal/ModalPrecioExtra.vue";
import Dialog from "@/components/base/Dialog";
import Headers from "../headers";
import moment from "moment";

export default {
  data() {
    return {
      headersExtras: Headers.headersExtras, 
      headersPrecios: Headers.headersPreciosExtras,
      abrirModal1: false,
      abrirModal2: false,
      extraStr: "Todos los extras",
      preciosStr: "Precios",
      itemActExtra: {
        nombre: null,
      },
      itemActPrecio: {
        extra: null,
        precio: null
      },
      objDeleteExtra: {
        element: "Extra",
        id: "",
        obj: {},
      },
      objDeletePrecio: {
        element: "Precio",
        id: "",
        obj: {},
      },
      update: false,
      detalle: false,
      adDialog1: false,
      adDialog2: false,
    };
  },
  components: {
    Table,
    Modal1,
    Modal2,
    Dialog,
  },
  async created() {
    moment.locale("ES");
  },
  computed: {
    ...mapState("usuarioNamespace", ["token", "usuario"]),
    ...mapState("extraNamespace", ["extra", "extras"]),
    ...mapState("precioExtraNamespace", ["precio_extra", "precio_extras"]),
  },
  methods: {
    ...mapActions("extraNamespace", [
      "getExtra",
      "getExtras",
      "saveExtra",
      "updateExtra",
      "deleteExtra",
    ]),
    ...mapActions("precioExtraNamespace", [
      "getPreciosExtra",
      "getPrecioExtras",
      "savePrecioExtra",
      "updatePrecioExtra",
      "deletePrecioExtra",
    ]),
    editarClickExtra(obj) {
      this.update = true;
      this.detalle = false;
      this.itemActExtra = obj;
      this.abrirModal1 = true;
    },
    editarClickPrecio(obj) {
      this.update = true;
      this.detalle = false;
      this.itemActPrecio = obj;
      this.abrirModal2 = true;
    },
    detalleClickExtra(obj) {
      this.detalle = true;
      this.update = false;
      this.itemActExtra = obj;
      this.abrirModal1 = true;
    },
    detalleClickPrecio(obj) {
      this.detalle = true;
      this.update = false;
      this.itemActPrecio = obj;
      this.abrirModal2 = true;
    },
    eliminarClickExtra(obj) {
      this.adDialog1 = true;
      this.objDeleteExtra.id = obj.id;
      this.objDeleteExtra.obj = obj;
    },
    eliminarClickPrecio(obj) {
      this.adDialog2 = true;
      this.objDeletePrecio.id = obj.id;
      this.objDeletePrecio.obj = obj;
    },
    nuevoExtra() {
      this.update = false;
      this.abrirModal1 = true;
    },
    nuevoPrecio() {
      this.update = false;
      this.abrirModal2 = true;
    },
    guardarExtra(obj) {
      debugger;
      if (this.update) {
        this.updateExtra({
          token: this.token,
          usuario: this.usuario._id,
          obj: obj,
        });
      } else {
        this.saveExtra({
          token: this.token,
          usuario: this.usuario._id,
          obj: obj,
        });
      }
      this.close();
      this.getExtras();
    },
    guardarPrecio(obj) {
      debugger;
      if (this.update) {
        this.updatePrecioExtra({
          token: this.token,
          usuario: this.usuario._id,
          obj: obj,
        });
      } else {
        this.savePrecioExtra({
          token: this.token,
          usuario: this.usuario._id,
          obj: obj,
        });
      }
      this.close();
      this.getExtras();
    },
    eliminarExtra(obj) {
      debugger;
      this.deleteExtra({
        token: this.token,
        id: obj,
      });
      this.close();
    },
    eliminarPrecio(obj) {
      debugger;
      this.deletePrecioExtra({
        token: this.token,
        id: obj,
      });
      this.close();
    },
    close() {
      this.detalle = false;
      this.update = false;
      this.objDeleteExtra = {};
      this.objDeletePrecio = {};
      this.itemActPrecio = {};
      this.itemActExtra = {};
      this.abrirModal1 = false;
      this.abrirModal2 = false;
      this.adDialog1 = false;
      this.adDialog2 = false;
    },
  },
};
</script>
